import React, { useState } from "react";
import { _t } from "core/language";
import Button, { type ButtonProps } from "./Button";
import CDialog from "./../CDialog";
import type { TCDialog } from 'core/interface/CDialog';
import { useSelector } from "react-redux";
import { useAuthModal } from "core/context";

type TButtonConfirm = {
  children?: React.ReactNode,
  message?: string | React.ReactNode,
  handleSubmit?: () => void,
  label?: string,
  className?: string,
  showWithAuth?: boolean,
  showModalConfirm?: boolean,
  id?: string,
  authRequired?: boolean,
  onClose?: () => void,
} & Omit<ButtonProps, 'label'> & Pick<TCDialog, 'submitText' | 'closeText'>

const ButtonConfirm = ({
  children,
  message,
  handleSubmit,
  label,
  className,
  showWithAuth,
  showModalConfirm = true,
  id,
  authRequired = false,
  onClose,
  ...rest
}: TButtonConfirm) => {
  const { openModal } = useAuthModal();
  const [open, setOpen] = useState<boolean>(false);
  const user = useSelector((state: any) => state.Auth.userInfo);
  if (showWithAuth && !user?.id) {
    return null
  }

  const _handleSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if(showModalConfirm) {
      setOpen(true);
    }else {
      handleSubmit?.();
    }
  }

  const onOpen = () => {
    if (authRequired && !user?.id && id) {
      openModal(() => {
        document.getElementById(id)?.click()
      });
      return;
    }
    setOpen(true);
  }

  return (
    <div className={className}>
      {children ? (
        <div onClick={onOpen} id={id || ''}>
          {children}
        </div>
      ) : (
        <Button
          label={_t(label || 'common.remove')}
          onClickBtn={_handleSubmit}
          {...rest}
        />
      )}
      
      <CDialog
        open={open}
        closeModal={() => {
            setOpen(false);
            onClose?.()
          }
        }
        title={''}
        handleSubmit={() => {
          setOpen(false);
          handleSubmit?.();
        }}
        buttonSize="sm"
        {...rest}
      >
        <div className="w-full text-center text-sm">
          {typeof message === 'string'
            ? <p>{_t(message as string || 'common.are_you_sure')}</p>
            : message as React.ReactNode
          }
        </div>
      </CDialog>
    </div>
  );
};

export default ButtonConfirm;
